<template>
  <div>
    <highcharts ref="chart" :options="chartOptions" />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (!this.$refs.chart) return;
      this.$refs.chart.chart.reflow();
    }, 200);
  },
  computed: {
    chartOptions() {
      return Object.assign({}, this.options, {
        credits: {
          enabled: false
        },
        chart: {
          type: "column",
          height: 200
        },
        title: {
          text: ""
        },
        yAxis: {
          min: 0,
          title: {
            text: ""
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: "",
          pointFormat: "{point.name}: {point.y}"
        }
      });
    }
  }
};
</script>

<style scoped></style>
